import { render, staticRenderFns } from "./AppAnnotationPart5.vue?vue&type=template&id=613b31e0&scoped=true"
import script from "./AppAnnotationPart5.vue?vue&type=script&lang=ts"
export * from "./AppAnnotationPart5.vue?vue&type=script&lang=ts"
import style0 from "./AppAnnotationPart5.vue?vue&type=style&index=0&id=613b31e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b31e0",
  null
  
)

export default component.exports